export default function CTASection() {
  return (
    <section className="relative w-full py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Bright%20modern%20retail%20storefront%20with%20large%20glass%20windows%20showcasing%20mannequins%20dressed%20in%20casual%20streetwear%20warm%20afternoon%20sunlight%20casting%20long%20gentle%20shadows%20across%20the%20sidewalk%20polished%20concrete%20exterior%20with%20potted%20plants%20urban%20shopping%20district%20atmosphere%20clean%20architectural%20style%20editorial%20commercial%20photography%20no%20text%20no%20logos%20no%20visible%20brand%20names&width=1600&height=700&seq=cta-v2-2026&orientation=landscape"
          alt="OOPBuy Spreadsheet shopping platform"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/55 via-black/35 to-black/25"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-start lg:items-end justify-between gap-8">
          <div className="max-w-lg">
            <h2 className="text-3xl md:text-5xl font-heading font-bold text-background-50 leading-tight mb-4">
              Ready to Optimize Your Shopping Workflow?
            </h2>
            <p className="text-sm md:text-base text-background-200/80 leading-relaxed">
              Start using the OOPBuy Spreadsheet system today and experience a smarter, faster way to shop. Join thousands of satisfied users who have transformed their purchasing process.
            </p>
          </div>

          <div className="flex-shrink-0">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-3 px-8 py-4 rounded-full bg-background-50 text-foreground-950 font-semibold text-sm hover:bg-background-100 transition-all cursor-pointer whitespace-nowrap group"
            >
              <span>Visit Main Platform</span>
              <div className="w-7 h-7 rounded-full bg-foreground-950 flex items-center justify-center group-hover:translate-x-1 transition-transform">
                <i className="ri-arrow-right-line text-background-50 text-sm"></i>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}